import React from 'react';
import { Sparkles } from 'lucide-react';

export default function SuperheroHero() {
  const scrollToGenerator = () => {
    document.getElementById('superhero-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1556707752-481d500a2c58?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Superhero silhouette against city skyline"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-violet-900 via-purple-800 to-violet-900 opacity-80"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Sparkles className="w-16 h-16 text-violet-400 animate-pulse" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Superhero Team Name Generator
        </h1>
        <p className="text-xl text-violet-100 mb-8 max-w-3xl mx-auto">
          Create epic names for your superhero team with our AI-powered generator.
          From cosmic crusaders to urban defenders, forge a legacy of legendary heroes.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-violet-700/50 px-4 py-2 rounded-full text-white text-sm border border-violet-500/30">
            Cosmic Powers
          </span>
          <span className="bg-violet-700/50 px-4 py-2 rounded-full text-white text-sm border border-violet-500/30">
            Legendary Teams
          </span>
          <span className="bg-violet-700/50 px-4 py-2 rounded-full text-white text-sm border border-violet-500/30">
            Epic Origins
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-violet-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-violet-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <Sparkles className="w-5 h-5" />
          Generate Superhero Team Names
        </button>
        <p className="mt-6 text-sm text-violet-200 bg-violet-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Join thousands of superhero teams worldwide
        </p>
      </div>
    </div>
  );
}